import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q8gu9by5sv: FaireBrandEntity = {
  token: "b_q8gu9by5sv",
  type: "brand",
  name: "LE LIS",
  avatarUrl:
    "https://cdn.faire.com/fastly/55fba71b13ada5059fbc21637a8a88f22ac0b4b34c4aa3c7fa4d4882f1c9a793.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fc8a4783771b535d693d93e9c17e7be84920ae3599c1c783167e82c2e0cd11e6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/55fba71b13ada5059fbc21637a8a88f22ac0b4b34c4aa3c7fa4d4882f1c9a793.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fc8a4783771b535d693d93e9c17e7be84920ae3599c1c783167e82c2e0cd11e6.png",
  location: "Vernon, CA, USA",
  minimumOrderDollars: 60,
  rating: 4.9,
  reviewCount: 353,
  isTopShop: true,
  isInsider: true,
  description:
    "LE LIS celebrates the vibrant spirit of today’s trendy young women. We want to empower women to express their individuality, feel confident, and turn heads with every outfit.\n\nThe LE LIS gal is the modern, trendy young woman – adventurous, bold, and full of life.  She’s the trendsetter amongst her friends, the go-getter pursuing her dreams, and she’s the life of the party. She knows what she wants and she looks good while getting it. LE LIS creates opportunities for styling to be a fun experience of exploration and discovery of her most beautiful and most confident self.\n\nThe collection focuses on delivering on-trend styles, with impeccable fit and quality.  LE LIS is dedicated to equipping its retail partners with the best products so that together, they can carry out their mission of empowering women to feel beautiful. The hope is that LE LIS isn’t just another clothing brand, but a reliable and strategic partner to all of its retailers.  ",
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:48:31.666Z",
    importedBy: "entity-db-cli",
  },
};
